export function Footer() {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="relative overflow-hidden border-t border-white/10 bg-[#043432] py-12 text-white">
			<div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(15,157,138,0.35),transparent_70%)] opacity-60" />
			<div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex flex-col gap-8">
					{/* Logo and Navigation Section */}
					<div className="flex flex-col items-center justify-between gap-6 md:flex-row">
						<div className="flex items-center gap-2 text-white">
							<img src="/logo.svg" alt="Squash" className="h-6 w-6" />
							<span className="font-semibold">Squash</span>
						</div>
						<nav className="flex flex-wrap items-center justify-center gap-4 text-sm text-white/70">
							<a
								href="#how-it-works"
								className="transition-colors hover:text-white"
							>
								How it works
							</a>
							<a
								href="#features"
								className="transition-colors hover:text-white"
							>
								Features
							</a>
							<a href="#team" className="transition-colors hover:text-white">
								Team
							</a>
							<a
								href="mailto:contact@trysquash.dev"
								className="transition-colors hover:text-white"
							>
								Contact
							</a>
						</nav>
					</div>

					{/* Copyright */}
					<div className="flex items-center justify-center text-sm text-white/70">
						<p>© {currentYear} Squash. All rights reserved.</p>
					</div>
				</div>
			</div>
		</footer>
	);
}
